import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { checkDashboardAccess } from '../../common/utils/checkTokenValidity';
import { ROUTES } from '../../constants/routes';
import { Loading } from '../common/Loading/Loading';
import { Stack, Theme } from '@mui/material';
import { authService } from '../../services/auth/AuthService';
import { useUserActions } from '../../hooks/useUser';

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  const { setAccessToDashboardCallback } = useUserActions();

  const checkAuth = async () => {
    const response = await authService.checkPermission();
    setAccessToDashboardCallback(response);
  };

  useEffect(() => {
    checkDashboardAccess().then((isValid) => {
      setIsAuthenticated(isValid);
    });

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return (
      <Stack
        sx={(theme: Theme) => ({
          minHeight: '100%',
          backgroundColor: theme.palette.gray[300],
        })}
      >
        <Loading />
      </Stack>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${ROUTES.LOGIN}`} />;
  }

  return <>{children}</>;
};

export default AdminRoute;
